import React from 'react'
import Main from "./Main";
import reducer from "../../store"
import withReducer from 'app/store/withReducer';

function Listing() {
    return <Main/>
};

export default withReducer('modulesApp', reducer)(Listing);